import { Box, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import bannerDestopImage from "../../assets/images/banner.mp4";

import Button from "../button";
import { Link } from "react-router-dom";
import { useState } from "react";
import { ClipLoader } from "react-spinners";

const Banner = () => {
  const [isLoadingNft, setIsLoading] = useState(false);
  const classes = useStyle();
  const isMobile = useMediaQuery("(max-width:899px)");
  const isNotMobile = useMediaQuery("(min-width:900px)");
  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.rightContainer}>
        <Box className={classes.headingContainer}>
          <Typography className={classes.heading}>
            Merging Historic Gold Prospecting Heritage with Blockchain
            Technology in a Revolutionary NFT Platform
          </Typography>
        </Box>
        <Box className={classes.titleContainer}>
          <Typography variant="body2" color="white" className={classes.title}>
            The Otago Gold Limited project was created by two experienced
            businessmen who have a passion for gold mining and a desire to share
            those experiences with others.
          </Typography>
          <Typography variant="body2" color="white" className={classes.title}>
            {" "}
            We have created an NFT project that allows crypto holders to be part
            of real world projects that earn PAX Gold airdrops which are dropped
            back to the token holder's wallets.
          </Typography>
          <Typography variant="body2" color="white" className={classes.title}>
            {" "}
            Our revolving tokens represent the journey gold takes from when it
            was formed in the stars, until it was mined by our project, and
            converted into gold stablecoins.
          </Typography>
          <Typography variant="body2" color="white" className={classes.title}>
            {" "}
            In addition to the PAX Gold airdrops, all token holders can access
            gold-rich areas owned by the project, where they can prospect for
            gold and keep what they find.
          </Typography>
          <Typography variant="body2" color="white" className={classes.title}>
            {" "}
            Selected token holders can participate in our larger scale mining
            projects and all token holders can join our premium gold mining
            tours.
          </Typography>
          <Typography variant="body2" color="white" className={classes.title}>
            {" "}
            Getting cold and wet in the rugged beauty of New Zealand isn't for
            everyone but it’s an opportunity to do something unique.
          </Typography>
          <Typography variant="body2" color="white" className={classes.title}>
            {" "}
            We look forward to having you join us!
          </Typography>
          {isMobile && (
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              {isLoadingNft && (
                <div className={classes.loader}>
                  {/* You can use a spinner or loading animation here */}
                  <ClipLoader color="#1976d2" size={50} />
                </div>
              )}
              <video
                muted
                src={bannerDestopImage}
                alt=""
                className={classes.imageBanner}
                autoPlay
                loop
                onCanPlay={() => setIsLoading(false)}
                onLoadStart={() => setIsLoading(true)}
              />
            </Box>
          )}
        </Box>

        <Box className={classes.auctionContainer}>
          {/* <Box sx={{ display: "flex", gap: "40px" }}>
            <Box className={classes.divider}>
              <Typography className={classes.inNumber}>10K</Typography>
              <Typography>Artwork</Typography>
            </Box>
            <Box className={classes.divider}>
              <Typography className={classes.inNumber}>32K</Typography>
              <Typography>Auction</Typography>
            </Box>{" "}
            <Box>
              <Typography className={classes.inNumber}>42K</Typography>
              <Typography>Artist</Typography>
            </Box>
          </Box> */}
          {isNotMobile && (
            <Box className={classes.barnnerAction} pt={3}>
              <Button
                sx={{ background: "#1976d2", padding: "10px 40px !important" }}
                variant="contained"
                component={Link}
                to="/browse"
              >
                Explore
              </Button>
              {/* <Button
                variant="outlined"
                sx={{
                  background: "transparent",
                  padding: "10px 40px !important",
                  border: "1px solid #1976d2 !important",
                  color: "#1976d2 !important",
                }}
                component={Link}
                to="/create"
              >
                Create
              </Button> */}
            </Box>
          )}
        </Box>
        {/* {isMobile && (
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <img src={bannerDestopImage} width="100%" alt="" />
          </Box>
        )} */}
      </Box>
      {isNotMobile && (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          {isLoadingNft && (
            <div className={classes.loader}>
              {/* You can use a spinner or loading animation here */}
              <ClipLoader color="#1976d2" size={50} />
            </div>
          )}
          <video
            muted
            src={bannerDestopImage}
            alt=""
            className={classes.imageBanner}
            autoPlay
            loop
            onCanPlay={() => setIsLoading(false)}
            onLoadStart={() => setIsLoading(true)}
          />
        </Box>
      )}
    </Box>
  );
};
export default Banner;
const useStyle = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    padding: "0px 0px",
    alignContent: "center",
    justifyContent: "space-between",

    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
      padding: "10px 10px",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      padding: "0px 0px 0px 0px",
    },
  },
  imageBanner: {
    objectFit: "contain",
    width: "70%",
    background: `url(${bannerDestopImage})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "contain",
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {
      marginTop: "10vh",
      width: "90%",
    },
  },
  loader: {
    position: "absolute",
    width: "70%",
    borderRadius: "20px",

    zIndex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: "50%",
    [theme.breakpoints.down("md")]: {
      minWidth: "50%",
      maxWidth: "90%",

      top: "0px",

      // maxHeight: "300px",
    },
  },
  heading: {
    textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    fontWeight: 600 + "!important",
    fontStyle: "normal !important",
    color: "white",
    fontSize: "40px !important",
    lineHeight: "43px !important",

    textTransform: "capitalize !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "50px !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "45px !important",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "24px !important",
      lineHeight: "38px !important",
      textAlign: "start !important",
    },
  },
  headingContainer: {
    width: "695px !important",
    [theme.breakpoints.down("lg")]: {
      width: "580px !important",
    },
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
  },
  titleContainer: {
    width: "695px !important",
    [theme.breakpoints.down("lg")]: {
      width: "550px !important",
    },
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
  },
  title: {
    marginTop: "10px !important",
    color: "#fff !important",
    fontSize: "20px !important",
    lineHeight: "20px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "18px !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "16px !important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px !important",
    },
  },
  auctionContainer: {
    padding: "0px",
    margin: "0px",
    color: "#fff",
    display: "flex",

    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      alignItems: "center",
      gap: 20,
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      gap: 10,
    },
  },
  inNumber: {
    fontSize: "28px !important",
    fontWeight: 700 + "!important",
    textTransform: "capitalize !important",
    color: "#A5A6F6",
  },
  divider: {
    borderRight: "1px solid #FFFFFF66",
    padding: "0 2rem 0 0",
  },
  barnnerAction: {
    display: "flex",

    gap: 30,
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 30,
    },
  },
  rightContainer: {
    padding: "50px 10px ",
    display: "flex",
    flexDirection: "column",

    gap: 30,
    justifyContent: "flex-start",
    [theme.breakpoints.down("lg")]: {
      width: "50%",
      gap: 30,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      justifyContent: "center !important",
      padding: "20px 0px",
      gap: 25,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center !important",
      padding: "10px 0px",
      gap: 10,
    },
  },
}));
